import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ dataComponents: { savedViews } }: ComposedTheme) => ({
  errorExclamation: {
    '& svg': {
      position: 'relative',
      top: -1,
      fill: savedViews.error.iconColor,
      marginRight: 8,
    },
  },
  error: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: [4, 16],
    height: 24,
    color: savedViews.error.text.color,
    '& span': savedViews.error.text.font,
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
    '& svg': {
      fill: savedViews.error.closeIconColor,
    },
  },
});

export default createUseStyles(styles);
